<template>
  <div v-loading.fullscreen.lock="loading">
    <!-- 问题产品提出 -->
    <el-dialog :title="$t('message.problemProductProposal')" :close-on-click-modal="false"
      :visible.sync="problemDialogVisible" width="1820px" :before-close="handleClose" center>
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 全选 -->
          <li class="flex05"> <el-checkbox v-model="checked" @change="allChecked"></el-checkbox></li>
          <!-- 番号 -->
          <li class="flex05">{{ $t("message.mash") }}</li>
          <!-- 二维码上传 -->
          <li>{{ $t("message.qrCodeUpload") }}</li>
          <!--  订单号-->
          <li class="flex15">
            {{ $t("message.orderNumber") }}
          </li>
          <!--照片-->
          <li>{{ $t("message.pic") }}</li>
          <!-- 商品属性 -->
          <li class="flex15">{{ $t("message.theBusinessEditsTheCommodityProperties") }}</li>
          <!--附加服务  -->
          <li class="flex15">{{ $t("message.additionalServices") }}</li>
          <!--业务报价  -->
          <li>{{ $t("message.businessOffer") }}</li>
          <!-- 客户付款后数量 -->
          <li>{{ $t("message.customerAfterPaymentQuantity") }}</li>
          <!--商品状态  -->
          <li>{{ $t("message.itemStatus") }}</li>
          <!-- 问题类别 -->
          <li class="flex15">{{ $t("message.typeOfProblem") }}</li>
          <!-- 问题图片 -->
          <li class="flex2">{{ $t("message.problemPic") }}</li>
          <!-- 问题产品数 -->
          <li>{{ $t("message.problemNunber") }}</li>
          <!-- 问题描述  -->
          <li class="flex2">
            {{ $t("message.problemDescription") }}
          </li>
          <!-- 修改后数量 -->
          <li class="important" v-if="isShow">
            {{ $t("message.editNumber") }}
          </li>
          <!-- 修改后单价.元 -->
          <li v-if="isShow" class="important">
            {{ $t("message.editPrice") }}.元
          </li>
          <!-- 修改后运费.元 -->
          <li v-if="isShow" class="important">
            {{ $t("message.editFreight") }}.元
          </li>
        </ol>
        <!-- 订单详情 -->
        <div class="problemStoreDetail" v-for="(item, index) in problemList" :key="index">
          <!-- 交易号 -->
          <div class="head">
            {{ $t("message.transactionNumber") }}:
            <a :href="'https://trade.1688.com/order/new_step_order_detail.htm?orderId=' + item.purchase_no"
              v-if="item.purchase_no" target="_blank">
              {{ item.purchase_no }}</a>
            <span v-else> ———— </span>
            <!-- 批量填充 -->
            <span class="btn"> <el-button size="mini" type="primary" @click="bulkFilling(index)">
                {{ $t('message.bulkFilling') }}</el-button></span>
          </div>
          <ul v-for="(items, indexs) in item.list" :key="indexs">
            <li class="flex05">{{ items.sorting }}</li>
            <!-- 选择 -->
            <li class="flex05">
              <label class="label">
                <el-checkbox v-model="items.checked" @change="changeItem"></el-checkbox>
              </label>
            </li>
            <!-- 番号 -->
            <li class="flex05">{{ items.sorting }}</li>
            <!-- 二维码上传 -->
            <li>
              <el-button @click="handlePictureCardPreview(items.qrcode_path, index, indexs, items.code)" type="primary"
                size="mini" class="qrCodeUpload">
                {{ $t("message.qrCodeUpload") }}
              </el-button>
            </li>
            <!--  店铺信息-->
            <li class="flex15">
              <div>
                <p>
                  <router-link :to="'orderPaymentDetail?order_sn=' + items.order_sn" class="a-link" target="_blank">
                    {{ items.order_sn }}</router-link>
                </p>
              </div>
            </li>
            <!--照片-->
            <li>
              <div class="img">
                <el-popover placement="right" width="300" trigger="hover">
                  <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                  <a :href="`https://detail.1688.com/offer/${items.goods_id}.html`" target="_blank" slot="reference">
                    <img :src="items.pic" alt="" />
                  </a>
                </el-popover>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="template">
                <p v-for="(skuItem, skuIndex) in items.detail_y" :key="skuIndex">
                  <span>{{ skuItem.key }}:</span>
                  <span>{{ skuItem.value }}</span>
                </p>
              </div>
            </li>
            <!--附加服务  -->
            <li class="flex15">
              <div class="scope">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex"
                      style="margin-bottom: 3px">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                  <div style="height: 100px">
                    <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                </el-tooltip>
              </div>

              <!-- <el-popover placement="bottom-start" width="400" trigger="click">
                <el-table :data="items.option" border size="mini" show-summary>
                  <el-table-column
                    property="name"
                    label="附加服务"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    property="num"
                    label="数量"
                    align="center"
                  ></el-table-column>
                  <el-table-column label="单价.元" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.price }}
                    </template>
</el-table-column>
<el-table-column label="小计.元" align="center" property="total">
</el-table-column>
</el-table>
<div class="template" slot="reference">


  <p v-for="opti in items.option" :key="opti.id">
    {{ opti.tag }}{{ opti.name }}{{ opti.num }}
  </p>
</div>
</el-popover> -->
            </li>
            <!--报价  -->
            <li>
              <div class="template">
                <!-- 单价 -->
                <!-- <p>
                  {{ $t("message.unitPrice") }}:{{ items.confirm_dicker_price }}
                </p> -->
                <!-- 价格 -->
                <p>{{ $t("message.price") }}:{{ items.confirm_price }}</p>

                <!-- 数量 -->
                <p>{{ $t("message.number") }}:{{ items.confirm_num }}</p>
                <!-- 运费-->
                <p>{{ $t("message.freight") }}:{{ items.confirm_freight }}</p>
              </div>
            </li>
            <!-- 客户 -->
            <li>
              <div class="template">
                <!-- 可入库 -->
                <p>
                  {{ $t("message.canBePutIntoStorage") }}:{{ items.possible_num ? items.possible_num : "——" }}
                </p>
                <!-- 已到货 -->
                <p>
                  {{ $t("message.itHasArrived") }}:{{ items.storage_num ? items.storage_num : "——" }}
                </p>
                <!-- 已出货 -->
                <p>
                  {{ $t("message.hasBeenShipped") }}:{{ items.p_num ? items.p_num : "——" }}
                </p>
              </div>
            </li>
            <!--商品状态  -->
            <li>{{ items.status }}</li>
            <!-- 问题类别 -->
            <li class="flex15">
              <el-select v-model="items.type" placeholder="空白" size="small" filterable @change="allType($event, items)">
                <el-option v-for="item in problemTypes" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </li>
            <!-- 问题图片 -->
            <li class="flex2">
              <div class="images">
                <div class="imgList">
                  <div class="imgs" v-for="(imgs, imgIndex) in items.image" :key="imgIndex"
                    @click="getIndex(index, indexs, imgIndex)">
                    <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'"
                      :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                      <img v-if="imgs.image" :src="imgs.image" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <!-- <el-checkbox v-model="imgs.checked"></el-checkbox> -->
                  </div>
                </div>
              </div>
            </li>
            <!-- 问题产品数 -->
            <li>
              <el-input v-model="items.num" :placeholder="$t('message.problemNunber')" size="small"
                @input="changeAccount(index, indexs, items, 'num', items.num)" type="number"
                onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')" onfocus="this.select()"></el-input>
            </li>
            <!-- 具体问题描述 -->
            <li class="flex2">
              <el-input v-model="items.description" type="textarea" :placeholder="$t('message.problemDescription')"
                onfocus="this.select()"
                @input="changeAccount(index, indexs, items, 'description', items.description)"></el-input>
            </li>
            <!-- 最终数量 -->
            <li v-if="isShow">
              <el-input v-model="items.pre_num" :placeholder="$t('message.finalQuantity')" size="small" type="number"
                onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')" onfocus="this.select()"
                @input="changeAccount(index, indexs, items, 'pre_num', items.pre_num)"> </el-input>
            </li>
            <!-- 最终单价 -->
            <li v-if="isShow">
              <el-input v-model="items.pre_price" :placeholder="$t('message.finalUnitPrice')" size="small" type="number"
                onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')" onfocus="this.select()"
                @input="changeAccount(index, indexs, items, 'pre_price', items.pre_price)"></el-input>
            </li>
            <!-- 最终运费 -->
            <li v-if="isShow">
              <el-input v-model="items.pre_freight" :placeholder="$t('message.finalFreightRate')" size="small"
                type="number" onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')" onfocus="this.select()"
                @input="changeAccount(index, indexs, items, 'pre_freight', items.pre_freight)"></el-input>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--提出问题产品  -->
        <el-button type="primary" @click="problemStore" style="margin-left: 50px">
          {{ $t("message.problemProductProposal") }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false" @close="getMobileUploadImage">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      checked: false,
      dialogImageUrl: '',
      indexs: {},
      checkedList: [],
      loading: false,
      isShow: localStorage.getItem('japanUserRoleStatus') != 5 ? true : false,
    };
  },
  computed: {
    problemList() {
      return this.$store.state.problemList;
    },
    problemDialogVisible() {
      return this.$store.state.problemDialogVisible;
    },
    problemTypes() {
      return this.$store.state.problemTypes;
    },
  },
  methods: {
    handleClose() {
      this.$confirm(this.$t("message.confirmTheShutDown"))
        .then((_) => {
          this.$store.commit("setProblemDialogVisible");
        })
        .catch((_) => { });
    },
    // 单选
    changeItem() {
      this.checkedList = [];
      let list = []
      this.problemList.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            this.checkedList.push(items);
          }
          list.push(items)
        });
      });
      this.checked = this.checkedList.length == list.length
      this.$forceUpdate();

    },
    // 全选
    allChecked() {
      this.checkedList = [];
      this.problemList.forEach((item) => {
        item.list.forEach((items) => {
          items.checked = this.checked
          this.checkedList.push(items);
        });
      });
      this.$forceUpdate();
    },
    // 获取图片索引
    getIndex(index, indexs, imgIndex) {
      this.indexs = {
        item_i: index,
        items_i: indexs,
        imgs_i: imgIndex,
      };

    },
    // 图片格式
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      // this.loading = true;
      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG和PNG 格式!");
        // this.loading = false;
      }
      return isJPG || isPNG;
    },
    //添加修改图片
    handleAvatarSuccess(file) {
      // this.loading = false;
      if (file.code != 0) return this.$message.error(file.msg);
      this.$message.success(file.msg);
      let image = this.problemList[this.indexs.item_i].list[this.indexs.items_i].image[
        this.indexs.imgs_i
      ]
      image.image = file.data;
      image.checked = true
      console.log(image);
      this.$forceUpdate();
    },
    //最大数量
    changeAccount(index, indexs, item, type, val) {
      if (item.num > item.confirm_num) {
        this.problemList[index].list[indexs].num = item.confirm_num;
      }
      if (item.checked) {
        this.problemList.forEach((item) => {
          item.list.forEach((items) => {
            if (items.checked) {
              items[type] = val
            }
          });
        });
      }

    },
    // 提出订单
    problemStore() {
      let datas = {
        data: [],
      };
      this.problemList.forEach((item) => {
        item.list.forEach((items) => {
          items.image.forEach(images => {
            images.client_show = images.checked ? 1 : 0
          })
          datas.data.push({
            order_detail_id: items.order_detail_id,
            order_purchase_id: items.order_purchase_id,
            description: items.description,
            num: items.num,
            image: items.image,
            inspect_bad_id: items.inspect_bad_id,
            type: items.type,
            pre_num: items.pre_num,
            pre_price: items.pre_price,
            pre_freight: items.pre_freight,
          });
        });
      });
      for (let i = 0; i < datas.data.length; i++) {
        if (!datas.data[i].num) {
          this.$alert("问题产品数未填写", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        if (!datas.data[i].type) {
          this.$alert("问题类别未选项", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
      }
      this.$api.problemApi.problemStore(datas).then((res) => {

        if (res.data.orderPurchaseIds != undefined) {
          res.msg = res.msg.replaceAll('\n', '<br/>',)
          this.$alert(res.msg, '提示', {
            dangerouslyUseHTMLString: true, center: true
          });
          return false
        }
        this.$message.success(res.msg);
        this.$store.commit("setProblemDialogVisible");
        this.$parent.problemStoreSuccess();
      });

    },
    //修改后数据计算
    calculateTheDataAfterModification() {
      this.problemList.forEach((item) => {
        item.list.forEach((items) => {
          items.pre_num = items.possible_num - items.num
        })
      })
      this.$forceUpdate()
    },
    //查看二维码
    handlePictureCardPreview(url, index, indexs, code) {
      this.indexs = {
        item_i: index,
        items_i: indexs,
        code,
      };
      this.$api.base64({}, url).then(res => {
        this.dialogImageUrl = res;
        this.dialogVisible = true;
      })


    },
    //手机上传查询上传的图片地址
    getMobileUploadImage() {
      let datas = {
        code: this.indexs.code
      }
      let image = this.problemList[this.indexs.item_i].list[this.indexs.items_i].image
      this.$api.problemApi.getMobileUploadImage(datas).then(res => {
        res.data.forEach((item, index) => {
          image[index].image = item.image
          image[index].checked = true
        })
        this.$forceUpdate()
      })

    },
    //问题类别全选
    allType(e, data) {
      if (data.checked) {
        this.problemList.forEach((item) => {
          item.list.forEach((items) => {
            if (items.checked) {
              items.type = e
            }
          });
        });
      }

    },
    //批量填充
    bulkFilling(i) {
      this.problemList[i].list.forEach(item => {
        item.num = item.possible_num
      })
    },
  },
};
</script>

<style lang='scss' scoped>
.table {
  padding: 24px;
  background-color: #f8f8f8;

  ol {
    display: flex;
    font-size: 14px;
    height: 40px;
    background: #edeff4;
    border-radius: 0px 4px 0px 0px;
    color: #909399;
    font-weight: 600;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
  }

  ul {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    padding: 15x 0;
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;



      .template {
        text-align: left;
        width: 100%;


        p {
          line-height: 20px;
        }
      }

      .scope {


        p {
          line-height: 22px;
        }
      }

      .images {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .imgList {
          display: flex;
          flex-wrap: wrap;
          width: 120px;

          .imgs {
            margin: 0 10px 10px 0;
            width: 55px;

            // position: relative;


            &:nth-child(even) {
              margin-right: 0;
            }

            &:nth-child(n + 2) {
              margin-bottom: 0;
            }
          }
        }
      }
    }

    .img {
      img {
        width: 55px;
        height: 55px;
      }
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 3px;


    .label {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.3;
    overflow: hidden;
  }

  .flex2 {
    flex: 1.8;
  }

  .problemStoreDetail {
    width: 100% !important;

    .head {

      height: 50px;
      display: flex;
      background: #545467;
      font-size: 14px;
      line-height: 50px;
      padding: 0 20px;
      color: #fff;
      position: relative;

      a {
        color: #fff;

        &:hover {
          text-decoration: underline;
        }
      }

      .btn {
        position: absolute;
        left: 69%;
      }
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }
}

/deep/.el-textarea__inner {
  height: 80px;
  padding: 3px;
}

.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;

  // position: relative;
  // width: 55px;
  // height: 55px;
  // overflow: hidden;
}

/deep/.el-upload,
.el-upload__input {
  width: 55px;
  height: 55px;
  margin-bottom: 5px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/.el-upload-dragger {
  width: 55px;
  height: 55px;
}

.avatar-uploader-icon {
  font-size: 20px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}

.avatar {
  width: 55px;
  height: 55px;
  display: block;
  border-radius: 3px;

}

.important {
  background-color: #fee0c3 !important;
  color: #333;
}

.qrCodeUpload {
  width: 80px !important;
  padding: 5px 0;
  text-align: center !important
}
</style>